import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { initI18n } from './i18n'
import { registerServiceWorker } from './pwa/register-sw'
import './styles/index.css'

// Before the first render: a component reading t() during mount must not get the
// key back because the catalog had not been registered yet.
initI18n()

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

// After the render call below would be tidier and is wrong: `registerServiceWorker`
// only attaches a `load` listener, and doing it here means the listener exists before
// React's first paint can possibly fire `load`.
registerServiceWorker()

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
